import { render } from "./SiteRiskDashboard.vue?vue&type=template&id=1b927472&scoped=true"
import script from "./SiteRiskDashboard.js?vue&type=script&lang=js"
export * from "./SiteRiskDashboard.js?vue&type=script&lang=js"

import "./SiteRiskDashboard.vue?vue&type=style&index=0&id=1b927472&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b927472"]])

export default __exports__